import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import icArrowRight from '../../static/icons/ic-arrow-right.svg'

const BreadCrumbStyle = styled.div`
  width: 100%;
  display: block;
  margin-bottom: 24px;
  ul.breadcrumb {
    padding: 10px 0;
    list-style: none;
    background-color: transparent;
  }
  ul.breadcrumb li {
    display: inline;
    font-size: 18px;
    font-family: 'Open Sans';
    font-weight: 600;
    line-height: 19px;
    margin-right: 20px;
    text-transform: uppercase !important;
    > a {
      text-decoration: none;
      color: #888888;
    }
    &:last-child {
      color: #ff7400;
    }
  }
  ul.breadcrumb li + li:before {
    padding: 8px;
    color: black;
    content: '';
    background-image: url(${icArrowRight});
    background-repeat: no-repeat;
    top: 9px;
    position: absolute;
    left: -21px;
  }
  ul.breadcrumb li + li {
    margin-left: 20px;
    position: relative;
  }

  @media screen and (min-width: 300px) and (max-width: 600px) {
    .breadcrumb {
      display: none;
    }
  }
`

const BreadCrumb = props => {
  const { options } = props
  return (
    <BreadCrumbStyle>
      <ul className="breadcrumb">
        {options.map((item, key) => {
          return (
            <li key={key}>
              {item.link ? <Link to={item.link}>{item.name}</Link> : item.name}
            </li>
          )
        })}
      </ul>
    </BreadCrumbStyle>
  )
}

export default BreadCrumb
